var FormKeyAccessValidate = $.extend({/* FormKeyAccessValidate */}, BaseComponent, {

	componentSelector: '#complete-access',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				keyaccess: {
					required: true
				}
			},
			submitHandler: function(form) {
				form.submit();
			}
		});

		$(element).find('#key-access-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));
	}

})